import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Introduction: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" gutterBottom>
          1. Introdução
        </Typography>
        <Typography variant="h5" gutterBottom>
          Política de Privacidade
        </Typography>
        <Typography variant="body1" paragraph>
          A INNOVA PLANO DE SAÚDE LTDA, pessoa jurídica inscrita no CNPJ sob o nº 48.982.275/0001-02, doravante denominada
          simplesmente “INNOVA PLANO DE SAÚDE”, reafirma seu compromisso com a privacidade e a proteção de dados pessoais de
          seus usuários, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018), bem como demais
          normas aplicáveis do ordenamento jurídico brasileiro, incluindo o Código de Defesa do Consumidor (Lei nº 8.078/1990).
        </Typography>
        <Typography variant="body1" paragraph>
          Esta Política de Privacidade foi elaborada com o objetivo de informar, de forma clara e transparente, as práticas adotadas pela
          INNOVA PLANO DE SAÚDE na coleta, no tratamento e no armazenamento de informações pessoais, assegurando a proteção
          da privacidade dos titulares de dados.
        </Typography>
        <Typography variant="body1" paragraph>
          Ao utilizar os serviços disponibilizados pela INNOVA PLANO DE SAÚDE, os usuários reconhecem e concordam com a coleta, o
          uso e o tratamento de suas informações pessoais conforme as disposições previstas nesta Política e em estrita observância às
          normas de proteção de dados e demais legislações aplicáveis.
        </Typography>
        <Typography variant="body1" paragraph>
          Na qualidade de Controladora dos Dados Pessoais tratados, a INNOVA PLANO DE SAÚDE compromete-se a cumprir rigorosamente
          as disposições aqui estabelecidas, garantindo os direitos dos titulares e a conformidade com os princípios da legislação de
          proteção de dados vigente.
        </Typography>
      </Box>
    </Container>
  );
};

export default Introduction;
